import { SelectOption } from '@7shifts/sous-chef';
import { __ } from 'i18n';

export const getHeaderTypeOptions = (): SelectOption<string>[] => [
    {
        label: __('messageTemplateForm.noneContentForm'),
        value: ''
    },
    {
        label: __('messageTemplateForm.textContentForm'),
        value: 'text'
    },
    {
        label: __('messageTemplateForm.imageContentForm'),
        value: 'image'
    },
    {
        label: __('messageTemplateForm.videoContentForm'),
        value: 'video'
    },
    {
        label: __('messageTemplateForm.documentContentForm'),
        value: 'document'
    }
];

export const getModelTypeOptions = (): SelectOption<string>[] => [
    {
        label: __('messageTemplateForm.modelTypeMarketing'),
        value: 'MARKETING'
    },
    {
        label: __('messageTemplateForm.modelTypeUtility'),
        value: 'UTILITY'
    }
];

export const VARIABLE_FIXED_VALUE = '__FIXED__';

export const getVariableTypeOptions = (): SelectOption<string>[] => [
    {
        label: __('messageTemplateForm.varOptionName'),
        value: '#NOME#'
    },
    {
        label: __('messageTemplateForm.varOptionNumber'),
        value: '#NUMERO#'
    },
    {
        label: __('messageTemplateForm.varOptionFixed'),
        value: VARIABLE_FIXED_VALUE
    }
];
